export default {
    meta: {
        title: '拓店宝-亚瑟士-评分解读'
    }
};
